import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import axios from "axios";
import {Status} from "./status";
import {headers} from "./headers";
import {Choice} from "./Shot";
import {host} from "./api";


export interface ChoiceState {
    status: Status,
    error: string | null | undefined
}

const initialState: ChoiceState = {
    status: Status.Idle,
    error: null,
}

export const saveChoice = createAsyncThunk('saveChoice', async (params: { projectId: number, narrationId: number, choice: Choice }) => {
    const response = await axios.post(`${host}/narrations/${params.narrationId}/choices`,
        params.choice,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const deleteChoice = createAsyncThunk('deleteChoice', async (params: { projectId: number, choiceId: number }) => {
    const response = await axios.delete(`${host}/choices/${params.choiceId}`,
        {
            headers: headers(params.projectId?.toString())
        })
    return response.data
})

export const choiceSlice = createSlice({
    name: 'choices',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
          .addCase(saveChoice.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(saveChoice.fulfilled, (state, action) => {
                state.status = Status.Idle
            })
            .addCase(deleteChoice.pending, (state, action) => {
                state.status = Status.Loading
            })
            .addCase(deleteChoice.fulfilled, (state, action) => {
                state.status = Status.Idle
            })

    }
})
export default choiceSlice.reducer;